import { Property } from '@app/react-common/components/rule-engine-v2/models/RuleEngineConfig';

export enum FeatureType {
  SHIPPING_RATES = 'SHIPPING_RATES',
  EXTENSIONS = 'EXTENSIONS',
}

export interface RulesByFeatureType {
  [FeatureType.SHIPPING_RATES]: Property[];
  [FeatureType.EXTENSIONS]: Property[];
}

export const SHIPPING_RATES_RULES: Property[] = [
  Property.customerOrderCount,
  Property.customerSpend,
  Property.customerTag,
  Property.gender,
  Property.cartValue,
  Property.weight,
  Property.hasACoupon,
  Property.grossMargin,
  Property.cartAttributeKey,
  Property.cartAttributeValue,
  Property.vendor,
  Property.collection,
  Property.productType,
  Property.shopify_tags,
  Property.variantTitle,
  Property.sellingPlan,
  Property.propertiesKey,
  Property.propertiesValue,
  Property.country,
  Property.subscription,
  Property.source,
  Property.weekday,
  Property.timeOfDay,
  Property.locale,
];

export const EXTENSIONS_RULES: Property[] = [
  Property.customerOrderCount,
  Property.customerSpend,
  Property.customerTag,
  Property.cartValue,
  Property.weight,
  Property.hasACoupon,
  Property.grossMargin,
  Property.productType,
  Property.variantTitle,
  Property.sellingPlan,
  Property.propertiesKey,
  Property.propertiesValue,
  Property.country,
  Property.weekday,
  Property.vendor,
  Property.collection,
  Property.shopify_tags,
  Property.subscription,
  Property.cartAttributeKey,
  Property.cartAttributeValue,
  Property.timeOfDay,
  Property.locale,
];

export const RULES_BY_FEATURE_TYPE: RulesByFeatureType = {
  [FeatureType.SHIPPING_RATES]: SHIPPING_RATES_RULES,
  [FeatureType.EXTENSIONS]: EXTENSIONS_RULES,
};

export const getRulesForFeatureType = (featureType: FeatureType): Property[] => {
  return RULES_BY_FEATURE_TYPE[featureType];
};

export const isRuleAvailableForFeatureType = (featureType: FeatureType, rule: Property): boolean => {
  return RULES_BY_FEATURE_TYPE[featureType]?.includes(rule) ?? false;
};
